import React, { FC } from 'react';

import { GoalDescriptor as GoalDescriptorType } from '~/core/types';

import { GoalDescriptor, GoalDescriptorsContainer } from './styles';

type Props = {
    goalDescriptors: Array<GoalDescriptorType>;
};

const GoalDescriptors: FC<Props> = ({ goalDescriptors }) => (
    <GoalDescriptorsContainer>
        {goalDescriptors.map((goalDescriptor, index) => (
            <GoalDescriptor key={index} title={goalDescriptor.long}>
                {goalDescriptor.short}
            </GoalDescriptor>
        ))}
    </GoalDescriptorsContainer>
);

export default GoalDescriptors;
